import {
  Box,
  Slider,
  SliderTrack,
  SliderFilledTrack,
  SliderThumb,
  SliderMark,
  Tooltip,
} from "@chakra-ui/react";
import React, { useRef } from "react";
import { observer } from "mobx-react-lite";
import useWindowObserver from "hooks/useWindowObserver";
import { useStores } from "stores/setup/use-store";

type TimeMarker = {
  index: number;
  label: string;
};

type TimelineForecastSliderProps = {
  totalFrames: number;
  currentIndex: number;
  timeMarkers: TimeMarker[];
  elapsedTime: string;
  onChange: (value: number) => void;
  onClick: () => void;
};

const TimelineForecastSlider: React.FC<TimelineForecastSliderProps> = ({
  totalFrames,
  currentIndex,
  timeMarkers,
  elapsedTime,
  onChange,
  onClick,
}) => {
  const {
    dataStores: { forecastChartMeteogramStore },
  } = useStores();
  useWindowObserver(".main-area");
  const containerRef = useRef(null);

  return (
    <Slider
      min={0}
      max={totalFrames - 1}
      value={currentIndex}
      onChange={onChange}
      step={1}
      flex="1"
      onClick={onClick}
    >
      {timeMarkers.map((marker, idx) => (
        <SliderMark
          key={idx}
          value={marker.index}
          mt="2"
          ml="-3"
          fontSize="xs"
          textAlign="center"
          whiteSpace="nowrap"
          color="#fff"
        >
          {marker.label}
        </SliderMark>
      ))}

      <SliderTrack bg="#dbecf7" position="relative">
        {timeMarkers.map((marker, i) => (
          <Box
            key={i}
            position="absolute"
            left={`${(marker.index / (totalFrames - 1)) * 100}%`}
            top={0}
            bottom={0}
            width="2px"
            bg="#858585"
            zIndex={2}
          />
        ))}

        <SliderFilledTrack bg="newBlue.500" />
      </SliderTrack>
      <Tooltip
        key={`${forecastChartMeteogramStore.openMeteogram}`}
        hasArrow
        bg={"newBlue.500"}
        color="white"
        placement="top"
        isOpen={true}
        fontSize="12px"
        label={elapsedTime}
        borderRadius="20px"
        boxShadow="0 0 5px rgba(0, 0, 0, 0.5)"
        portalProps={{
          containerRef: containerRef,
          appendToParentPortal: true,
        }}
      >
        <SliderThumb ref={containerRef} bg="#fff" />
      </Tooltip>
    </Slider>
  );
};

export default observer(TimelineForecastSlider);
